
import React from 'react';
import { formatCurrencyShort } from '../../data/utils/money-utils';
import { cn } from '@/lib/utils';
import { useLanguage } from '../../contexts/language';

interface PledgeAmountProps {
  amount: number;
  className?: string;
}

const PledgeAmount: React.FC<PledgeAmountProps> = ({ amount, className }) => {
  const { t } = useLanguage();
  
  return (
    <span className={cn("font-nasalization text-[#0E4D66]", className)}>
      {formatCurrencyShort(amount)}
    </span>
  );
};

export default PledgeAmount;
